export default "__VITE_ASSET__DTClYAW8__"